const CONTRACTS_KEY = 'contracts';

export function loadContracts() {
    try {
        const raw = localStorage.getItem(CONTRACTS_KEY);
        return raw ? JSON.parse(raw) : [];
    } catch (e) {
        console.error('[contractService] loadContracts() failed', e);
        return [];
    }
}

export function saveContracts(contracts) {
    try {
        localStorage.setItem(CONTRACTS_KEY, JSON.stringify(contracts));
    } catch (e) {
        console.error('[contractService] saveContracts() failed', e);
    }
}

export function addContract(contract) {
    const current = loadContracts();
    current.push(contract);
    saveContracts(current);
}
